export class HttpRequest {
    constructor(params) {
        this.headers = {};
        this.pathParameters = {};
        this.queryParameters = {};
        this.bypassErrorHandler = false;
        this.responseType = 'object';
        this.method = params.method;
        if (params.host) {
            this.host = params.host;
        }
        if (params.path) {
            this.path = this.processPath(params.path, params.pathParameters);
        }
        if (params.url) {
            this.url = params.url;
        }
        if (params.headers) {
            this.headers = params.headers;
        }
        if (params.pathParameters) {
            this.pathParameters = params.pathParameters;
        }
        if (params.queryParameters) {
            this.queryParameters = params.queryParameters;
        }
        this.bodyParameters = params.bodyParameters;
        this.timeout = params.timeout;
        this.bypassErrorHandler = params.bypassErrorHandler;
        if (params.responseType) {
            this.responseType = params.responseType;
        }
        if (params.onUploadProgress) {
            this.onUploadProgress = params.onUploadProgress;
        }
        if (params.refreshTokenMethod) {
            this.refreshTokenMethod = params.refreshTokenMethod;
        }
    }
    processPath(path = "/", pathParameters = {}) {
        path = path.charAt(0) !== "/" ? `/${path}` : path;
        if (pathParameters) {
            Object.keys(pathParameters).map((key) => {
                path = path.replace(':' + key, encodeURIComponent(pathParameters[key]));
            });
        }
        return path;
    }
    getUrl() {
        if (this.host) {
            return `${this.host}${this.path}`;
        }
        else {
            return this.url;
        }
    }
}
export class HttpResponse {
    constructor(params) {
        this.statusCode = params.status;
        this.headers = params.headers || {};
        this.body = params.body;
    }
}
